// @ts-strict-ignore
import React, { useEffect } from 'react'
import dayjs from 'dayjs'
import { Box, Button, Icon } from '@node-space/ui-components'
import { logError } from '@node-space/utils'
import { DateFormat } from 'constants/General'
import { usePaymentCaseDocumentQuery } from 'hooks/queries/usePaymentCaseDocumentQuery'
import { PaymentCaseDocument as PaymentCaseDocumentType } from 'types/payments'

interface PaymentCaseDocumentProps {
  paymentCaseDocument: PaymentCaseDocumentType
  testId?: string
}

const dateFormat = DateFormat.HH_MM_DD_MMM_YYYY

export const PaymentCaseDocument = ({ paymentCaseDocument, testId }: PaymentCaseDocumentProps) => {
  const {
    data: documentData,
    isFetching: isFetchingDocument,
    refetch,
  } = usePaymentCaseDocumentQuery(paymentCaseDocument?.id)

  useEffect(() => {
    if (!documentData) return

    try {
      const url = window.URL.createObjectURL(new Blob([documentData]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute(
        'download',
        `${paymentCaseDocument?.id}_${paymentCaseDocument?.title}.${paymentCaseDocument?.fileExtension}`
      )
      document.body.appendChild(link)
      link.click()
    } catch (error) {
      logError(`Error: case - downloadDocument`, error)
    }
  }, [documentData])

  return (
    <Box>
      <Box flex gapX={4} gapY={4} justify="between" className="flex-col-reverse sm:flex-row">
        <Box testId={testId} gapX={4} flex>
          <Button
            iconElement={<Icon name="DownloadSimple" size="small" />}
            noPadding
            loading={isFetchingDocument}
            variant="ghost"
            onClick={() => refetch()}
          >
            {paymentCaseDocument?.pathOnClient}
          </Button>
        </Box>
        <Box>
          <p className="h-full flex text-body-regular-small text-foreground-subdued items-center sm:pb-0.5">
            {dayjs(paymentCaseDocument?.createdDate).format(dateFormat)}
          </p>
        </Box>
      </Box>
      <Box width="full">
        <p className="text-body-regular-small text-foreground-subdued">
          {paymentCaseDocument?.title}
        </p>
      </Box>
    </Box>
  )
}
